export const transactionsConstants = {
  SET_TRANSACTIONS_LAST_UPDATE: 'SET_TRANSACTIONS_LAST_UPDATE',
}
